import { createSlice } from "@reduxjs/toolkit";
import { get_basket_thunk } from "./thunks/get_basket_thunk";
import { calculate_basket_thunk } from "./thunks/calculate_basket_thunk";
import { redeem_voucher_thunk } from "./thunks/redeem-voucher";
const slice = createSlice({
    name: "basket",
    initialState: {
        addingToBasket: {
            id: "",
            isAddingToBasket: false,
        },
        isLoading: false,
        payment_identifier: "",
        basket: null,
        product_list: [],
        delivery_method: "delivery",
        checkout_cookie: "",
    },
    reducers: {
        setBasket: (state, action) => {
            state.basket = action.payload;
        },
        setCheckedOutBasket: (state, action) => {
            state.checkout_cookie = action.payload;
        },
        // setPaymentIdentifiers: (state, action) => {
        //   state.payment_identifier = action.payload.payment_identifier;
        // },
        setDeliveryMethod: (state, action) => {
            state.delivery_method = action.payload;
        },
        setIsAddingToBasket: (state, action) => {
            state.addingToBasket = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(get_basket_thunk.fulfilled, (state, action) => {
            // console.log("get_basket_thunk.fulfilled", action);
            state.addingToBasket.isAddingToBasket = false;
            state.addingToBasket.id = "";
        })
            .addCase(get_basket_thunk.rejected, (state, action) => {
            // console.log("get_basket_thunk.rejected", action);
            state.addingToBasket.isAddingToBasket = false;
            state.addingToBasket.id = "";
        })
            .addCase(get_basket_thunk.pending, (state, action) => {
            // console.log("get_basket_thunk.pending", action);
            state.addingToBasket.isAddingToBasket = true;
        })
            .addCase(calculate_basket_thunk.fulfilled, (state) => {
            state.addingToBasket.isAddingToBasket = false;
            state.addingToBasket.id = "";
        })
            .addCase(calculate_basket_thunk.rejected, (state) => {
            state.addingToBasket.isAddingToBasket = false;
            state.addingToBasket.id = "";
        })
            .addCase(redeem_voucher_thunk.fulfilled, (state, action) => {
            state.isLoading = false;
        })
            .addCase(redeem_voucher_thunk.rejected, (state, action) => {
            state.isLoading = false;
        })
            .addCase(redeem_voucher_thunk.pending, (state, action) => {
            state.isLoading = true;
        });
    },
});
export const { setBasket, 
//setPaymentIdentifiers,
setDeliveryMethod, setCheckedOutBasket, setIsAddingToBasket, } = slice.actions;
export default slice.reducer;
